"use client";

import { useSyncExternalStore } from "react";

/**
 * Vrai une fois la page hydratée ; faux sur le serveur **et** pendant
 * l'hydratation.
 *
 * # Pour ce que le serveur ne peut pas savoir
 *
 * Une date en heure locale dépend du fuseau du visiteur, que le serveur Next
 * (en UTC dans son conteneur) ignore. La rendre côté serveur, c'est écrire
 * « 16:39 » là où le navigateur écrira « 18:39 » — et React 19 refuse un
 * texte qui diffère à l'hydratation : il jette l'arbre et le refait côté
 * client, avec une erreur en console. Ce hook laisse rendre un blanc de la
 * même hauteur tant que le fuseau n'est pas connu, puis la vraie valeur dès
 * le premier rendu client.
 *
 * # `useSyncExternalStore` et non un effet
 *
 * Un `useState(false)` passé à `true` dans un effet est le réflexe habituel ;
 * il cascade un rendu de plus et la règle `set-state-in-effect` le refuse. Le
 * magasin externe rend la bonne valeur sans effet : l'instantané serveur vaut
 * `false`, celui du client vaut `true`, et React fait la transition lui-même
 * juste après l'hydratation.
 */
const subscribe = () => () => {};

export function useHydrated(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => true,
    () => false,
  );
}
